import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Notification from 'components/Notification';

class Heading extends React.Component {
  renderNotifications(notifications) {
    return notifications.map((notification) => {
      const currentTime = +new Date();

      // if notification was created less than 2 seconds ago
      if (currentTime - notification.createdAt <= 2000) {
        const notificationProps = {
          key: notification.createdAt,
          message: notification.message,
          type: notification.type,
          link: notification.link
            ? { text: notification.link.text, to: notification.link.to }
            : null,
        };

        return <Notification {...notificationProps} />;
      }

      return null;
    });
  }

  render() {
    const notifications = this.renderNotifications(this.props.notifications);
    const { location } = this.props;
    const isDocumentationPage = location.pathname.startsWith('/documentation');

    const helpProps = {
      className: 'button button-link',
      href: 'https://autodesk.slack.com/messages/CF9QHHQ85',
      target: '_blank',
      rel: 'noopener noreferrer',
    };

    return (
      <React.Fragment>
        <div id="ZN_298m7asUWd8cSNL"></div>

        <div className="notifications">{notifications}</div>

        {!isDocumentationPage && (
        <header className="heading-wrapper">
          <a {...helpProps}>Help</a>
        </header>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  notifications: state.notifications.notifications,
  lastNotificationAt: state.notifications.lastNotificationAt,
});

export default withRouter(connect(mapStateToProps)(Heading));
